var TargetPlatform = /** @class */ (function () {
    function TargetPlatform(id, printableName) {
        this.id = id;
        this.printableName = printableName;
    }
    return TargetPlatform;
}());
export default TargetPlatform;
